import "./ShowReferenceStatisticsPage.css"

import pageIds from "constants/pageIds.constants.json"
import GENERAL_TEXTS, { REFERENCESTATISTICS_TEXTS } from "constants/text.constants"
import pageTitles from "constants/pageTitles.constants.json"

import { useEffect, useState } from "react"

import useScrollToTop from "hooks/useScrollToTop"
import useUpdatePageTitle from "hooks/useUpdatePageTitle"

import { fetchComparisonstatistics, fetchTableViewData } from "services/fetchers"

import { Icomparisonstatistic, ITableView, ITableViewRow } from "types/sharedTypes"

import { ReactComponent as ChevronDownIcon } from "components/menu/icons/chevron-down.icon.svg"

import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from "react-accessible-accordion"

import Error from "components/atoms/error/Error"
import PageHeader from "components/cores/pageHeader/PageHeader"
import Confirmation from "components/atoms/confirmation/Confirmation"
import ContentSkeleton from "components/atoms/contentSkeleton/ContentSkeleton"
import ReferenceStatisticsContent from "./components/ReferenceStatisticsContent"

const ShowReferenceStatisticsPage = () => {
    const [noStatistics, setNoStatistics] = useState(false)
    const [fetchingComparisonstatistics, setFetchingComparisonstatistics] = useState(true)
    const [fetchError, setFetchError] = useState("")

    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false)

    const [tableViewById, setTableViewById] = useState<Record<string, ITableView[]>>({})
    const [tableViewRowsById, setTableViewRowsById] = useState<Record<string, ITableViewRow[]>>({})
    const [fetchingTableViewById, setFetchingTableViewById] = useState<Record<string, boolean>>({})
    const [fetchTableViewErrorById, setFetchTableViewErrorById] = useState<Record<string, string>>({})
    // const [tableView, setTableView] = useState<ITableView[]>()
    // const [tableViewRows, setTableViewRows] = useState<ITableViewRow[]>()

    const [comparisonstatistics, setComparisonstatistics] = useState<Icomparisonstatistic[]>()

    const [expandedId, setExpandedId] = useState("")

    // const handleFetchTable = (id: string) => {
    //     if (expandedId === id) setExpandedId("")
    //     else setExpandedId(id)
    //     fetchTableViewData(id, setTableViewById, setTableViewRowsById, setFetchingTableViewById, setFetchTableViewErrorById)
    // }
    const handleFetchTable = async (id: string) => {
        if (expandedId === id) {
            setExpandedId("")
            
            return
        }

        setExpandedId(id)

        // skip om redan laddad
        if (tableViewById[id])
            
             return

        setFetchingTableViewById((prev) => ({ ...prev, [id]: true }))
        setFetchTableViewErrorById((prev) => ({ ...prev, [id]: "" }))

        try {
            const { tableView, rows } = await fetchTableViewData(id)

            setTableViewById((prev) => ({
                ...prev,
                [id]: tableView,
            }))

            setTableViewRowsById((prev) => ({
                ...prev,
                [id]: rows,
            }))
        } catch (error: any) {
            setFetchTableViewErrorById((prev) => ({
                ...prev,
                [id]: error?.statusText ?? GENERAL_TEXTS.FETCH_ERROR_GENERIC,
            }))
        } finally {
            setFetchingTableViewById((prev) => ({ ...prev, [id]: false }))
        }
    }

    useEffect(
        () =>
            fetchComparisonstatistics(
                setComparisonstatistics,
                setNoStatistics,
                setFetchingComparisonstatistics,
                setFetchError
            ),
        []
    )

    // console.log(comparisonstatistics)

    useUpdatePageTitle(pageTitles.SHOW_REFERENCESTATISTICS_PAGE_TITLE)
    useScrollToTop()

    return (
        <>
            <PageHeader pageId={pageIds.SHOW_REFERENCESTATISTICS_PAGE_ID} />
            {fetchingComparisonstatistics && !fetchError && <ContentSkeleton />}
            {noStatistics && !fetchingComparisonstatistics && <p>{REFERENCESTATISTICS_TEXTS.NO_STATISTICS}</p>}
            {fetchError && <Error>{fetchError}</Error>}
            {showDeleteConfirmation && (
                <div className="marginBottom32">
                    <Confirmation>{REFERENCESTATISTICS_TEXTS.CONFIRMATION_DELETED}</Confirmation>
                </div>
            )}
            {!fetchingComparisonstatistics && !noStatistics && !fetchError && comparisonstatistics && (
                <div className="maxWidth1000">
                    <Accordion allowZeroExpanded>
                        {comparisonstatistics.map((statistic) => {
                            const data = tableViewById[statistic.Id]
                            const isLoading = fetchingTableViewById[statistic.Id] === true
                            const error = fetchTableViewErrorById[statistic.Id]

                            return (
                                <AccordionItem key={statistic.Id}>
                                    <AccordionItemHeading
                                        onClick={() => handleFetchTable(statistic.Id)}
                                        onKeyDown={(e) => {
                                            if (e.code === "Space" || e.code === "Enter") {
                                                handleFetchTable(statistic.Id)
                                            }
                                        }}
                                    >
                                        <AccordionItemButton>
                                            <div className="flex jc-space-between">
                                                <div className="responsiveHeadingTextContainer gap32">
                                                    <p className="headingTextRef">
                                                        <strong>{REFERENCESTATISTICS_TEXTS.PERIOD}</strong>
                                                        {statistic.ValidFor}
                                                    </p>
                                                    <p className="headingTextRef">
                                                        <strong>{REFERENCESTATISTICS_TEXTS.EMPLOYEE_TYPE}</strong>
                                                        {statistic.StatisticFor === "ExcludingManagers"
                                                            ? REFERENCESTATISTICS_TEXTS.EMPLOYEES
                                                            : REFERENCESTATISTICS_TEXTS.MANAGERS}
                                                    </p>
                                                    <p className="headingTextRef">
                                                        <strong>{REFERENCESTATISTICS_TEXTS.IMPORTED_BY}</strong>
                                                        {statistic.ImportedBy}
                                                    </p>
                                                    {statistic.ImportedBy !== "Arbetsgivarverket" && (
                                                        <p className="headingTextRef">
                                                            <strong>{REFERENCESTATISTICS_TEXTS.FILENAME}</strong>
                                                            {statistic.FileName}
                                                        </p>
                                                    )}
                                                </div>
                                                <div className="iconContainer">
                                                    {expandedId === statistic.Id ? (
                                                        <ChevronDownIcon width="1rem" height="1rem" fill="#aa0e4c" />
                                                    ) : (
                                                        <ChevronDownIcon
                                                            width="1rem"
                                                            height="1rem"
                                                            fill="#333333"
                                                            transform="rotate(180)"
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </AccordionItemButton>
                                    </AccordionItemHeading>

                                    <AccordionItemPanel>
                                        {isLoading && <ContentSkeleton />}

                                        {!isLoading && error && <Error>{error}</Error>}

                                        {!isLoading && !error && !data && <ContentSkeleton />}

                                        {!isLoading && !error && data && data.length === 0 && (
                                            <p>{REFERENCESTATISTICS_TEXTS.NO_STATISTICS}</p>
                                        )}

                                        {!isLoading && !error && data && data.length > 0 && (
                                            <ReferenceStatisticsContent
                                                tableView={data}
                                                tableViewRows={tableViewRowsById[statistic.Id] ?? []}
                                                importedBy={statistic.ImportedBy}
                                                fetchingTableView={false}
                                                fetchError=""
                                                setComparisonstatistics={setComparisonstatistics}
                                                setShowConfirmation={setShowDeleteConfirmation}
                                            />
                                        )}
                                    </AccordionItemPanel>
                                </AccordionItem>
                            )
                        })}

                    </Accordion>
                </div>
            )}
        </>
    )
}

export default ShowReferenceStatisticsPage
